export const repair_detail = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Repair",
  title: "Repair",
  back_to_repairs: "Back to repairs",
  status_updates_heading: "Status updates",
  already_closed: "This repair is closed.",
};
